<script>
    export let fill = '#FFF'
</script>

<style>
    svg#team-info-tab-bar {
        position: absolute;
        width: 414px;
        height: 50px;
        top: 93px;
        left: 0;
    }
</style>

<svg id="team-info-tab-bar" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 414 50">
    <g id="topbar">
        <rect {fill} width="414" height="50"/>
    </g>
</svg>